import React, { useState, useEffect } from "react";
import { Box, Typography, Paper, Button, IconButton } from "@mui/material";
import { firestore,storage } from "../../config/firebase.js";
import { useNavigate } from "react-router-dom";
import { Delete, Edit } from "@mui/icons-material";
import Linkify from "react-linkify";
import { Link } from "react-router-dom";
import ImageModal from "../../utils/ImageModal.js";
import { Modal } from "antd";

import { collection, getDocs, deleteDoc, doc, query } from "firebase/firestore";
import { State, City } from "country-state-city";
import moment from "moment";
import StoryModal from "./storyModal.js";
import { ref, deleteObject } from "firebase/storage";
const SuccessStory = () => {
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();
  const [selectedPost, setSelectedPost] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedPostId, setSelectedPostId] = useState({
    id: null,
    image: null,
  });
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [stateCode, setStateCode] = useState("");

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const handleCloseImageModal = () => {
    setSelectedImage(null);
  };

  const handleEditClick = (post) => {
    setSelectedPost(post);
    setModalOpen(true);
  };

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const postsQuery = query(collection(firestore, "success_story"));

        const querySnapshot = await getDocs(postsQuery);
        const data = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setPosts(data);

      } catch (error) {
        console.error("Error fetching data from Firebase:", error);
      }
    };

    fetchPosts();
  }, []);

  useEffect(() => {
    if (!stateList.length) {
      setStateList([
        ...State.getStatesOfCountry("IN").map((el, index) => {
          return { value: el.isoCode, label: el.name };
        }),
      ]);
    }
  }, []);

  useEffect(() => {
    if (stateCode) {
      setCityList([
        ...City.getCitiesOfState("IN", stateCode).map((el) => {
          return { label: el.name };
        }),
      ]);
    }
  }, [stateCode]);

  const handleDeletePost = async (postId) => {
    try {
      await deleteDoc(doc(firestore, "university", postId));
      setPosts((prevPosts) => prevPosts.filter((post) => post.id !== postId));
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };

  const handleDeleteClick = (postId, link) => {
    setSelectedPostId({ id: postId, image: link });
    setDeleteModalVisible(true);
  };

  const handleDeleteConfirmed = async () => {
    try {
      const oldImageRef = ref(storage, selectedPostId.image);
      deleteObject(oldImageRef).then((r) => {
        alert("success");
      });
      await deleteDoc(doc(firestore, "success_story", selectedPostId.id));
      setPosts((prevPosts) =>
        prevPosts.filter((post) => post.id !== selectedPostId)
      );
      setDeleteModalVisible(false);
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };

  const handleDeleteCancelled = () => {
    setDeleteModalVisible(false);
  };

  return (
    <div>
      <Modal
        title="Confirm Deletion"
        open={isDeleteModalVisible}
        onOk={handleDeleteConfirmed}
        onCancel={handleDeleteCancelled}
        okText="Yes"
        cancelText="No"
      >
        Are you sure you want to delete this story?
      </Modal>

      <Box className="dashboard">
        <Button
          variant="contained"
          color="primary"
          style={{ marginBottom: "20px", marginTop: "25px" }}
          onClick={() => {
            navigate("/add-story");
          }}
        >
          Add Story
        </Button>
        {posts.map((post) => (
          <Paper
            key={post.id}
            elevation={3}
            style={{
              padding: "28px",
              textAlign: "center",
              maxWidth: "600px",
              margin: "20px",
              height: "300px",
              position: "relative",
              borderRadius: "15px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              overflow: "auto",
              scrollbarWidth: "thin",
              scrollbarColor: "#ccc #f4f4f4",
            }}
          >
            <Typography
              variant="subtitle2"
              style={{
                position: "absolute",
                top: "10px",
                left: "20px",
                color: "#555",
              }}
            >
              {moment(post.timeStamp).format("DD/MMM/YYYY")}
            </Typography>
            <IconButton
              style={{
                position: "absolute",
                top: "10px",
                left: "500px",
                color: "black",
              }}
              onClick={() => handleEditClick(post)}
            >
              <Edit />
            </IconButton>
            <StoryModal
              isOpen={isModalOpen}
              onClose={() => setModalOpen(false)}
              selectedUniversity={selectedPost}
            />
            <IconButton
              style={{
                position: "absolute",
                top: "10px",
                right: "20px",
                color: "black",
              }}
              color="secondary"
              onClick={() => {
                const link = post?.images ? post?.images : post?.video;
                handleDeleteClick(post.id, link);
              }}
            >
              <Delete />
            </IconButton>
            <Typography
              style={{
                marginBottom: "20px",
                marginTop: "10px",
                maxHeight: "150em",
                overflow: "hidden",
                wordWrap: "break-word",
                wordBreak: "break-all",
              }}
              variant="h5"
            >
              {post.title}
            </Typography>

            <Typography
              variant="body1"
              style={{
                maxHeight: "250em",
                overflow: "hidden",
                wordWrap: "break-word",
                wordBreak: "break-all",
              }}
            >
              <Linkify
                componentDecorator={(decoratedHref, decoratedText, key) => (
                  <Link to={decoratedHref} target="_blank" key={key}>
                    {decoratedText}
                  </Link>
                )}
              >
                {post.content}
              </Linkify>
            </Typography>

            {post?.images ? (
              <img
                src={post.images}
                style={{
                  maxWidth: "100%",
                  margin: "10px",
                  cursor: "pointer",
                }}
                onClick={() => handleImageClick(post.images)}
              />
            ) : (
              <video width="100%" controls style={{ borderRadius: 30 }}>
                <source src={post.video} type="video/mp4" />
              </video>
            )}
          </Paper>
        ))}
      </Box>
      <ImageModal imageUrl={selectedImage} onClose={handleCloseImageModal} />
    </div>
  );
};

export default SuccessStory;
